import { defineNuxtPlugin } from '#imports'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import 'dayjs/locale/en'

export default defineNuxtPlugin((nuxtApp: any) => {
  // Подписываемся на изменение языка через глобальный объект i18n
  if (nuxtApp.$i18n) {
    nuxtApp.$i18n.onLanguageSwitched = (oldLocale: string, newLocale: string) => {
      // Set dayjs locale when language is switched
      dayjs.locale(newLocale)
      // Здесь можно добавить дополнительную логику при смене языка
      // Например, обновление данных пользователя
      // nuxtApp.$auth.fetchUser()
    }
    // Set initial dayjs locale
    dayjs.locale(nuxtApp.$i18n.locale)
  }
}) 